export const rowCustomFieldsWrapperStyles = {
  marginTop: '24px',
};
